// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".icon-border[data-v-700b2ede]{border-radius:3.491px;border:.582px solid hsla(0,0%,100%,.35);background:hsla(0,0%,100%,.3);box-shadow:0 0 6.982px 0 rgba(0,0,0,.05)}.soru[data-v-700b2ede]{flex-shrink:0;border-radius:4.465px;border:.744px solid hsla(0,0%,100%,.35);box-shadow:0 0 8.93px 0 rgba(0,0,0,.05)}.swiper-pagination1[data-v-700b2ede]{display:grid;gap:8px;position:relative;left:0;transform:none;width:unset}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
